import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  SettingHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      justifyContent: 'center'
    },
    '& h6': {
      fontSize: theme.typography.pxToRem(16) + '!important'
    }
  },
  valueWrapper: {
    margin: theme.spacing(0, 2),
    '& .MuiChip-colorPrimary': {
      minWidth: 70,
      color: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(18)
    }
  },
  formWrapper: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  BasicInfoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      },
      [theme.breakpoints.up('sm')]: {
        margin: 0,
        minHeight: 40,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
        display: 'flex',
        alignItems: 'center',
        paddingRight: theme.spacing(2)
      }
    },
    '& .MuiOutlinedInput-root': {
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0
    },
    '& .MuiFormControl-root:not(.auto)': {
      width: 340,
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    },
    '& a': {
      display: 'block',
      width: '100%',
      textAlign: 'right'
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
    },
    [theme.breakpoints.up('sm')]: {
      '&:not(.auto)': {
        maxWidth: 510
      }
    }
  },
  AddAdminSubmit: {
    color: theme.palette.common.white,
    background: theme.palette.primary.light,
    border: 'none',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(0.9375, 6),
    borderBottomRightRadius: 4,
    borderTopRightRadius: 4,
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(4)
    },
    '&:disabled': {
      pointerEvents: 'none',
      opacity: 0.7
    },
    '&:hover, &:focus': {
      opacity: 0.7
    }
  },
  radiosWrapper: {
    flexDirection: 'row',
    marginTop: theme.spacing(0.75),
    '& label': {
      minWidth: '40%',
      '&.fixed': {
        minWidth: 170
      }
    }
  }
}))
